import React from "react";

import { IconProps } from "../../types/common";

const InactiveParticipantIcon = ({
  width = "16",
  height = "16",
  style,
  className,
  fillClassName,
  fillColor = "#E64040",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 16 16"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.06 2.5c.17 0 .34.07.47.2l9.97 9.97a.66.66 0 11-.94.94L4.7 7.75 3.03 6.08l-.25-.25-2.2-2.2a.66.66 0 01.48-1.13z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M2 4.04v7.65c0 .67.54 1.21 1.21 1.21h7.65l-1.2-1.21h-1.6v-1.21h.38l-1.6-1.6v.39h-1.2V8.06h.38l-1-1-.6-.6v.38h-1.2v-1.2h.38l-.42-.43-.28-.28-.9-.9zm8.51 6.44l-.03-.04V9.27h1.21v1.2h-1.18zm1.21 1.2h.57a.6.6 0 00.61-.6V6.24a.6.6 0 00-.6-.6H8.05v1.2h1.2v1.22H8.1L6.84 6.8V5.63H5.67L4.42 4.4V3.2H3.25l-.88-.87c.22-.21.52-.34.84-.34h3.63c.67 0 1.22.54 1.22 1.21v1.21h4.84c.67 0 1.21.55 1.21 1.21v6.06c0 .67-.54 1.21-1.21 1.21h-.19a.73.73 0 00-.21-.43l-.78-.78zm-7.3 0h-1.2v-1.2h1.2v1.2zm-1.2-2.41h1.2V8.06h-1.2v1.2zm3.62 2.42h-1.2v-1.21h1.2v1.2zm-1.2-7.27h1.2v-1.2h-1.2v1.2zm4.84 2.42h1.21v1.22h-1.21V6.84z"
    />
  </svg>
);

export default InactiveParticipantIcon;
